"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _constants = require("./constants");
/**
 * Handles configurable truncating of pagination items.
 *
 * @param {object} props
 * @param {React.Element[]} items
 * @param {number} truncateAbove
 * @param {number} numberOfPagesBeforeEllipsis
 */
function usePagination(_ref) {
  let {
    items,
    truncateAbove,
    numberOfPagesBeforeEllipsis
  } = _ref;
  const activeItemIndex = Math.max(items.findIndex(item => item.props.isActive), 0 // default to the first item if none is marked as active
  );
  const getItemProps = index => {
    const {
      onPress,
      href,
      hrefAttrs,
      variant,
      tokens
    } = items[index]?.props ?? {};
    return {
      onPress,
      href,
      hrefAttrs,
      variant,
      tokens
    };
  };
  let windowSize;
  if (numberOfPagesBeforeEllipsis >= 1 && numberOfPagesBeforeEllipsis < items.length) {
    windowSize = numberOfPagesBeforeEllipsis;
  } else if (truncateAbove > _constants.TRUNCATE_ABOVE_VALUE) {
    windowSize = _constants.MIN_PAGES_TO_SHOW;
  } else {
    windowSize = _constants.DEFAULT_PAGE_TO_SHOW_VALUE;
  }
  const truncateEnabled = items.length > windowSize;
  const truncateWindowStart = windowSize;
  const truncateWindowEnd = items.length - 1 - windowSize;

  // basically how many items next to the currently active one do we want to render
  const activeWindowStart = activeItemIndex - (windowSize - 1) / 2;
  const activeWindowEnd = activeItemIndex + (windowSize - 1) / 2;
  const isFirstActive = activeItemIndex === 0;
  const isLastActive = activeItemIndex === items.length - 1;

  // start truncating when the active item is within the truncate window
  const isLeftTruncated = truncateEnabled && activeItemIndex >= truncateWindowStart;
  const isRightTruncated = truncateEnabled && activeItemIndex <= truncateWindowEnd;
  function shouldRenderEllipsis(itemIndex) {
    const isNextToFirst = itemIndex === 1;
    const isNextToLast = itemIndex === items.length - 2;
    return isLeftTruncated && isNextToFirst || isRightTruncated && isNextToLast;
  }
  function shouldRenderButton(itemIndex) {
    const isFirst = itemIndex === 0;
    const isLast = itemIndex === items.length - 1;
    const isInActiveWindow = itemIndex >= activeWindowStart && itemIndex <= activeWindowEnd;
    return isFirst || isLast || isInActiveWindow || !isLeftTruncated && itemIndex <= truncateWindowStart || !isRightTruncated && itemIndex >= truncateWindowEnd;
  }
  return {
    showPrevious: !isFirstActive,
    showNext: !isLastActive,
    shouldRenderButton,
    shouldRenderEllipsis,
    isItemActive: itemIndex => itemIndex === activeItemIndex,
    getItemProps,
    nextItemProps: getItemProps(activeItemIndex + 1),
    previousItemProps: getItemProps(activeItemIndex - 1)
  };
}
var _default = exports.default = usePagination;